<section class="request-dialog">
  <!-- dialog header -->
  <div class="request-dialog__header">
    <!-- title -->
    <h4 class="request-dialog__title">{{ title | translate }}</h4>
    <!-- close button -->
    <button (click)="close()">
      <i class="iconsax request-dialog__icon" icon-name="x"></i>
    </button>
  </div>

  <!-- dialog content -->

  <section class="request-dialog__content">
    <!-- <div class="request-item"> -->
    <!-- description -->
    <!-- <p class="request-item__description">
        {{ 'products.requestToSample' | translate }}
      </p> -->
    <!-- submit button -->
    <!-- <a
        class="request-item__button"
        [href]="panelUrl + '/orders/create/' + productId">
        <pwj-button
          variant="primary"
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          >{{ 'global.submit' | translate }}</pwj-button
        >
      </a>
    </div> -->

    <div class="request-item">
      <!-- description -->
      <p class="request-item__description">
        {{ 'products.requestToProduct' | translate }}
      </p>

      <!-- submit button -->
      <a
        class="request-item__button"
        [href]="panelUrl + '/orders/create/' + productId"
        [class.pointer-events-none]="userBusinessId === productBusinessId">
        <pwj-button
          [variant]="
            userBusinessId === productBusinessId ? 'secondary' : 'primary'
          "
          icon="chevron-right"
          [rotateIconInRtl]="true"
          [iconReversePosition]="true"
          [disabled]="userBusinessId === productBusinessId"
          >{{ 'global.submit' | translate }}</pwj-button
        >
      </a>
    </div>
  </section>
</section>
